export default __webpack_public_path__ + "img/6093c657135f385cd987e86cb180c87d.png";